import React from 'react';
import { NavLink } from 'react-router-dom';

import { getImageFullPath } from '../../core';

const CardBlog = (props) => {
  // const [newsData, setNewsData] = useState(props.data);

  function removeEmptyPTags(html) {
    // Use a DOM parser to remove empty <p> tags
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const paragraphs = doc.querySelectorAll('p');

    paragraphs.forEach((p) => {
      if (!p.textContent.trim()) {
        p.remove(); // Remove empty <p> tags
      }
    });

    return doc.body.innerHTML;
  }

  const sanitizedDescription = removeEmptyPTags(props.data.desc);

  return (
    <NavLink
      to={`/news/detail/${props.data.id}`}
      className='wrapper__card-blog color__black d-inline-block w-100'
    >
      <img
        src={getImageFullPath(`uploads/news/${props.data.img}`)}
        className='img'
        alt=''
      />
      <div className='desc'>
        <div className='d-flex align-items-center mb-2'>
          <h5 className='mb-0 semi-bold font__size--14 text__14-1024 text-uppercase color__gray-1'>
            {props.data.date}
          </h5>
        </div>
        <div className='mb-2 bold font__size--20 text__20-1024 text-uppercase clamp__2 '>
          {props.data.title}
        </div>
        <p
          className='normal font__size--16 text__16-1024  clamp__3'
          dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
        />
        <div className='d-inline-block'>
          <span className='color__blue text-uppercase text__16-1024'>
            იხილეთ სრულად
          </span>
        </div>
      </div>
    </NavLink>
  );
};

export default CardBlog;
